import React from 'react';
import QnA from '../components/setting/QnA';

const QnAPage: React.FC = () => {
  return (
    <div className="main-container">
      <QnA mode="create" />
    </div>
  );
};

export default QnAPage;
